import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'

export default class {
    @observable list = []
    @observable loading = false
    @observable item = {}
    @observable index = 0
    constructor(name) {
        this.url = name
    }
    @action async get(map) {
        this.loading = true
        const d = await http.get(this.url, map)
        this.list = d
        this.loading = false
        return d
    }
    @action async post(map, name) {
        this.loading = true
        const d = await http.post(this.url, map)
        this.list = d.res
        this.loading = false
        return d.res
    }
    @action set(index, val) {
        this.index = index
        this.list[index] = val || this.list[index]
        this.item = val || this.list[index]
    }
    @action setItem(val) {
        this.item = val
    }
}


// WEBPACK FOOTER //
// ./store/list.js